/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransactionDetail
 */
export interface TransactionDetail {
    /**
     * 
     * @type {number}
     * @memberof TransactionDetail
     */
    amountSource: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetail
     */
    amountTarget: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    clientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    clientLastName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    clientSecondInitial: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    companyName: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDetail
     */
    currentTimestamp: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDetail
     */
    endDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDetail
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    intermediaryFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    intermediaryLastName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    planName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    planNumber: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    reportName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    transactionCategory: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDetail
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetail
     */
    detailOfTransaction: string;
}

/**
 * Check if a given object implements the TransactionDetail interface.
 */
export function instanceOfTransactionDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amountSource" in value;
    isInstance = isInstance && "amountTarget" in value;
    isInstance = isInstance && "clientFirstName" in value;
    isInstance = isInstance && "clientLastName" in value;
    isInstance = isInstance && "clientSecondInitial" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "currentTimestamp" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "intermediaryFirstName" in value;
    isInstance = isInstance && "intermediaryLastName" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "planNumber" in value;
    isInstance = isInstance && "reportName" in value;
    isInstance = isInstance && "transactionCategory" in value;
    isInstance = isInstance && "transactionDate" in value;
    isInstance = isInstance && "detailOfTransaction" in value;

    return isInstance;
}

export function TransactionDetailFromJSON(json: any): TransactionDetail {
    return TransactionDetailFromJSONTyped(json, false);
}

export function TransactionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amountSource': json['AmountSource'],
        'amountTarget': json['AmountTarget'],
        'clientFirstName': json['ClientFirstName'],
        'clientLastName': json['ClientLastName'],
        'clientSecondInitial': json['ClientSecondInitial'],
        'companyName': json['CompanyName'],
        'currentTimestamp': (new Date(json['CurrentTimestamp'])),
        'endDate': (new Date(json['EndDate'])),
        'startDate': (new Date(json['StartDate'])),
        'intermediaryFirstName': json['IntermediaryFirstName'],
        'intermediaryLastName': json['IntermediaryLastName'],
        'planName': json['PlanName'],
        'planNumber': json['PlanNumber'],
        'reportName': json['ReportName'],
        'transactionCategory': json['TransactionCategory'],
        'transactionDate': (new Date(json['TransactionDate'])),
        'detailOfTransaction': json['DetailOfTransaction'],
    };
}

export function TransactionDetailToJSON(value?: TransactionDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AmountSource': value.amountSource,
        'AmountTarget': value.amountTarget,
        'ClientFirstName': value.clientFirstName,
        'ClientLastName': value.clientLastName,
        'ClientSecondInitial': value.clientSecondInitial,
        'CompanyName': value.companyName,
        'CurrentTimestamp': (value.currentTimestamp.toISOString()),
        'EndDate': (value.endDate.toISOString()),
        'StartDate': (value.startDate.toISOString()),
        'IntermediaryFirstName': value.intermediaryFirstName,
        'IntermediaryLastName': value.intermediaryLastName,
        'PlanName': value.planName,
        'PlanNumber': value.planNumber,
        'ReportName': value.reportName,
        'TransactionCategory': value.transactionCategory,
        'TransactionDate': (value.transactionDate.toISOString()),
        'DetailOfTransaction': value.detailOfTransaction,
    };
}

